import React, { useEffect } from 'react'
import { func, object } from 'prop-types'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import { useFormContext } from '../../Form'
import { Button } from '../../Button'
import { SubmitButton } from '../SubmitButton'
import { EmailInput, FirstNameInput, LastNameInput, UsernameInput } from '../Inputs'

const StyledButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

export const FormFields = ({ onExit, errors }) => {
  const { setErrors, setSubmitting } = useFormContext()

  useEffect(() => {
    if (errors) {
      setErrors(errors)
      setSubmitting(false)
    }
  }, [errors])

  return (
    <>
      <EmailInput />
      <FirstNameInput />
      <LastNameInput />
      <UsernameInput />
      <StyledButtonWrapper>
        <FormattedMessage
          id='UserMenuDropdown.Logout'
          defaultMessage='Logout'
          description='The button text for the logout button.'
        >
          {(formattedText) => (
            <Button onClick={onExit} size='medium'>
              {formattedText}
            </Button>
          )}
        </FormattedMessage>
        <FormattedMessage
          id='Authentication.CompleteProfileFlow.CompleteProfile'
          defaultMessage='Complete Profile'
          description='The button text for the complete profile button.'
        >
          {(formattedText) => <SubmitButton>{formattedText}</SubmitButton>}
        </FormattedMessage>
      </StyledButtonWrapper>
    </>
  )
}

FormFields.propTypes = {
  onExit: func,
  errors: object,
}
